declare global {
  interface Window {
    fbq: (
      action: string,
      eventName: string,
      params?: Record<string, any>
    ) => void;
  }
}

export const MetaPixelEvents = {
  Lead: 'Lead',
  CompleteRegistration: 'CompleteRegistration',
  Contact: 'Contact',
  Subscribe: 'Subscribe',
  Purchase: 'Purchase',
  ViewContent: 'ViewContent',
  AddToCart: 'AddToCart',
} as const;

export type MetaPixelEventName = typeof MetaPixelEvents[keyof typeof MetaPixelEvents];

export const trackMetaPixelEvent = (
  eventName: MetaPixelEventName,
  params?: Record<string, any>
): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, params);
      console.log(`[Meta Pixel] Tracked event: ${eventName}`, params);
    } catch (error) {
      console.error('[Meta Pixel] Error tracking event:', error);
    }
  } else {
    console.warn('[Meta Pixel] fbq not available');
  }
};

export const trackRegistrationStarted = (): void => {
  // No PII - UTMs and fbclid handle attribution
  trackMetaPixelEvent(MetaPixelEvents.Lead, {
    content_name: 'Registration Started',
  });
};

export const trackRegistrationCompleted = (): void => {
  // No PII sent to Meta Pixel - UTMs + fbclid handle attribution
  // Standard e-commerce fields for optimization
  trackMetaPixelEvent(MetaPixelEvents.CompleteRegistration, {
    content_name: 'User Registration',
    status: 'completed',
    value: 0, // Can be updated later with LTV estimate
    currency: 'GBP',
  });
};
